/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FloorOrder = {
    properties: {
        floors: {
    type: 'array',
    contains: {
        type: 'Floor',
    },
    isRequired: true,
},
    },
};